import * as yup from "yup";

export const SheetEditBookingSchema = yup.object().shape({
  take: yup
    .number()
    .typeError("Take % é obrigatório")
    .min(1, "Take não pode ser menor que 1")
    .required("Take % é obrigatório"),
  credits: yup
    .number()
    .typeError("Créditos são obrigatórios")
    .min(1, "Créditos não podem ser menor que 1")
    .required("Créditos são obrigatórios"),
  transfer: yup
    .number()
    .typeError("Repasse é obrigatório")
    .min(1, "Repasse não pode ser menor que 1")
    .required("Repasse é obrigatório"),
});
